import React, { ReactNode } from 'react'
import { Icon } from 'semantic-ui-react'
import usePlayerActions from '../../hooks/usePlayerActions'
import { useSelector } from '../../../../hooks/useSelector'
import PromiseMenuItem from '../../../../components/PromiseMenuItem'
import formatCost from '../../../../utils/formatCost'
import { round } from 'lodash'
import { calcQuest } from './calculateQuestBonus'
import { Card, Cards, Popup, Stack, Typography } from '@prometheus/components'
import PromiseCard from '@/components/PromiseCard'

interface LOCRateUpgradesPopupProps {
  children: ReactNode
}

export default ({ children }: LOCRateUpgradesPopupProps) => {
  const loc_rate_upgrades = useSelector(s => s.game.options?.loc_rate_upgrades) || []
  const loc = useSelector(s => s.game.sheet?.loc)
  const level = loc?.rate_level
  const prime_rate = useSelector(s => s.game.metadata?.prime_rate) || 0
  const credit_risk = + (useSelector(s => s.game.sheet?.credit_risk_adjusted_rate) || 0)
  const quest_loc_bonus = useSelector(s => s.game.sheet?.quests.rewards.loc_rate_bonus)
  const rate_additions = (credit_risk + prime_rate + calcQuest(quest_loc_bonus || [])) * 100
  if (typeof level !== 'number') {
    return null
  }
  const {
    onUpgrade,
  } = usePlayerActions()

  return (
    <Popup hoverable position="bottom right" trigger={children}>
      <Card padding="sm" style={{ width: 'min(400px, calc(100vw - 20px))' }}>
        <Stack>
          <Typography variant="h4">LOC Rate Upgrades <Typography variant="h4" component="span" color="secondary">Level {level + 1}</Typography></Typography>
          <Cards>
            {loc_rate_upgrades.map(({ cost, rate }, i) => {
              const disabled = i > level + 1
              const isNextUpgrade = i === level + 1
              const isUpgraded = i <= level
              let color: string | undefined = undefined;
              if (isUpgraded) color = 'var(--prometheus-secondary)'
              else if (disabled) color = 'var(--prometheus-gray-500)'
              let onClick
              if (isNextUpgrade) {
                onClick = () => onUpgrade('loc_rate')
              }
              return (
                <PromiseCard padding="sm" key={rate} ignoreGameLogic interactive disabled={disabled} onClick={onClick}>
                  <Stack direction="row" style={{ justifyContent: 'space-between' }}>
                    <Typography bold style={{ color }}>Level {i + 1} | Rate: { round(rate + rate_additions, 2) }%</Typography>
                    {isNextUpgrade && (<Icon name="angle double up" style={{ color: 'var(--prometheus-primary)' }} size="large" />)}
                    {isUpgraded && (<Icon name="check square" style={{ color: 'var(--prometheus-secondary' }} size="large" />)}
                  </Stack>
                  <Typography style={{ color }}>{formatCost(cost)}</Typography>
                </PromiseCard>
              )
            })}
          </Cards>
        </Stack>
      </Card>
    </Popup>
  )
}
